<template lang="pug">

  section.texto
    slot

</template>

<script>
  export default  {
    name: 'Texto',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .texto {
    font-size: 1rem;
    line-height: 1.6rem;
  }
</style>
